const PageNotFound = () => 
  import(/* webpackChunkName: 'PageNotFound' */ '@/Core/404');
const Dashboard = () => 
  import(/* webpackChunkName: 'Dashboard' */ '@/Core/Dashboard');
const Settings = () => 
  import(/* webpackChunkName: 'Settings' */ '@/Core/Settings');
const Profile = () => 
  import(/* webpackChunkName: 'Profile' */ '@/Core/Profile');
const Sunset = () => 
  import(/* webpackChunkName: 'Sunset' */ '@/Core/Sunset');

export const dashboard = {
  path: '/dashboard',
  name: 'dashboard',
  component: Dashboard,
  meta: { auth: true },
};

export const settings = {
  path: '/settings',
  name: 'settings',
  component: Settings,
  meta: { auth: true },
};

export const profile = {
  path: '/profile',
  name: 'profile',
  component: Profile,
  meta: { auth: true },
};

export const sunset = {
  path: '/sunset',
  name: 'sunset',
  component: Sunset,
  // No navbar page, but requires authentication to access
  meta: { auth: true },
};

export const fallback = {
  path: '*',
  component: PageNotFound,
};

export default [
  dashboard,
  settings,
  profile,
  sunset,
  fallback,
];
